"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteAlert = exports.DELETE_ALERT_ACTION_TYPE = void 0;

var _fluxActions = require("flux-actions");

var _identity = _interopRequireDefault(require("transmute/identity"));

var DELETE_ALERT_ACTION_TYPE = 'DELETE_ALERT';
exports.DELETE_ALERT_ACTION_TYPE = DELETE_ALERT_ACTION_TYPE;
var deleteAlert = (0, _fluxActions.createAction)(DELETE_ALERT_ACTION_TYPE, _identity.default);
exports.deleteAlert = deleteAlert;